import { CHILDREN_SAVINGS_LIMITS } from "shared/CalculatorLimits";
import { CHILDREN_SAVINGS_REASONS } from "shared/CalculatorReasons";
import { SavingsCalculator } from "web_myplann/Calculators/Components/SavingsCalculator";
import { CHILDREN_SAVINGS_YEARS_DEFAULT } from "web_myplann/Calculators/constants";
import { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const ChildrenSavingsCalculatorPage = () => {
	const { t } = useResource();

	return (
		<SavingsCalculator
			type={CalculatorType.ChildrenSavings}
			reasonLabel={t(Resources.Calculators.Savings.ChildrenReason)}
			reasons={CHILDREN_SAVINGS_REASONS}
			reasonNode={Resources.Calculators.Savings.ChildrenReasons}
			yearsMin={CHILDREN_SAVINGS_LIMITS.yearsMin}
			yearsMax={CHILDREN_SAVINGS_LIMITS.yearsMax}
			yearsDefault={CHILDREN_SAVINGS_YEARS_DEFAULT}
		/>
	);
};
